import React,{useState,useEffect} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import AuthUser from '../AuthUser';
import AlertMessage from '../Utils/AlertMessage'
import { useParams } from 'react-router-dom';
function ResetPassword() {
    const { http} = AuthUser();
    const [password, setPassword] = useState("Abc.@678");
    const [values,setValues]=useState({password:'',confpassword:''});
    const [errors, setErrors] = useState({password:'',confpassword:'' });
    const [successMessage, setSuccessMessage] = useState('');
    const {token,email} = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [submitted, setsubmitted] = useState(false);
    const [message,setMessage]=useState();
    const[show,setShow]=useState(false);
    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Validate email
        if (!values.password.trim()) {
            newErrors.password = 'Password is required';
            isValid = false;
        } else {
            newErrors.password = '';
        }

        // Validate password
        if (!values.confpassword.trim()) {
            newErrors.confpassword = 'Password is required';
            isValid = false;
        } else {
            newErrors.confpassword = '';
        }

        setErrors(newErrors);
        return isValid;
    };
    const handlePassword = (event) => {
        let new_pass = event.target.value;
        let new_name = event.target.name;
        
        setPassword(new_pass);
        setValues({...values,[new_name]:event.target.value})
        const newErrors = { ...errors };
        // regular expressions to validate password
        var lowerCase = /[a-z]/g;
        var upperCase = /[A-Z]/g;
        var numbers = /[0-9]/g;
        if (!new_pass.match(lowerCase)) {
            newErrors.new_name = "Password should contains lowercase letters!";
        } else if (!new_pass.match(upperCase)) {
            newErrors.new_name = "Password should contain uppercase letters!";
        } else if (!new_pass.match(numbers)) {
            newErrors.new_name = "Password should contains numbers also!";
        } else if (new_pass.length < 8) {
            newErrors.new_name = "Password length should be more than 8.";
        } else {
            newErrors.new_name='';
        }
    }
    const handleSubmit = async (e) =>{
        e.preventDefault();
        //validation(values);
        let password = values.password;
        let confpassword = values.confpassword;        
        let token = e.target.token.value;
        let email = e.target.email.value;
        const newErrors = { ...errors };
        if (validateForm()) {
            
            var body = {pswd:password,confirm_password:confpassword,token:token,email:email};
            http.post(`admin/reset-password`,body).then((response)=>{
              //setToken(response.data.userdetail,response.data.token);
              //console.log(response.status);
              console.log(response.data);
              setMessage('Password reset successfully!');
              setShow(true);
              
          }).catch(function (error) {
            // handle error
            console.log(error);
            //console.log(error.response.data.error);
            
            if(error?.response?.status==403){
              newErrors.password = error.response.data?.error?.password;
              newErrors.confpassword = error.response.data?.error?.confpassword;
              setErrors(newErrors);
            }
            if(error.response.status==401){
              newErrors.message = error.response.data?.error;
              setErrors(newErrors);
            }
            
            //setsubmitted(false)
          })
        } else {
          // Form is not valid, display error messages
    
        }
    }

    return (
      <Container fluid>
  
        <Container className='mt-2'>
          <Row className='min-vh-75'>
            <Card className='rounded-0 ' style={{ width: '25rem', margin: 'auto' }}>
              <Card.Body>
                <p className='fw-bold'>Reset Password</p>
                <hr></hr>
                <Row className='p-2 '>
                  <Form method="POST" onSubmit={handleSubmit}>                    
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <Form.Label>New Password *</Form.Label>
                      <Form.Control type="password" name='password' onChange={handlePassword} placeholder="Enter New Password" className='rounded-0' />
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "block" }}
                      >
                        {errors.password}
                      </Form.Control.Feedback>
  
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                      <Form.Label>Re-confirm Password *</Form.Label>
                      <Form.Control type="password" name='confpassword' onChange={handlePassword} placeholder="Enter Re-confirm Password" className='rounded-0' />
                      <Form.Control.Feedback
                        type="invalid"
                        style={{ display: "block" }}
                      >
                        {errors.confpassword}
                      </Form.Control.Feedback>
                      <AlertMessage
                      message={message}
                      type="success"
                      timeout={3000} // Clear after 5 seconds
                      onClear={() => setMessage("")}
                    />   
                    </Form.Group>
                    <Col className='text-center'>
                      <Button variant="secondary" className='rounded-0'>Cancel</Button>
                      <Button variant="primary" type="submit" onClick={validateForm} className='rounded-0 ml-2'>Submit</Button>
                    </Col>
                  </Form>
                </Row>
              </Card.Body>
            </Card>
          </Row>
        </Container>
  
      </Container>
    );
}

export default ResetPassword
